const EximEmailType = {
  INDENT_CREATE: 'create_indent',
  FREIGHT_FORWARDER_REJECT: 'freight_forwarder_reject',
  MASTER_INDENT_UPDATE: 'master_indent_update',
  CONTAINER_BOOKED: 'container_booked',
  MASTER_INDENT_RE_INDENT: 'master_indent_re_indent',
  DELIVERED_TO_CONSIGNEE: 'delivered_to_consignee',
};

const EximEmailSubject = {
  INDENT_CREATE: 'New Export Indent Created!',
};


module.exports = { EximEmailType, EximEmailSubject };
